import React from "react";
import "../styles/tsp.scss";
import TspHeader from "../components/layout/TspHeader";
import TspFooter from "../components/layout/TspFooter";

// TSP's real page shell: its own header/nav/footer (see Phase A plan — TSP
// renders its own chrome on /tsp/* routes instead of the shared ICC
// Header/Footer, to match the Figma design). All TSP-scoped styles live
// under the `.tsp-app` root class below so they can never leak onto ICC
// pages that don't render this layout.
export default function TspLayout({ children }) {
  return (
    <div className="tsp-app">
      <TspHeader />
      <main className="tsp-main">{children}</main>
      <TspFooter />
    </div>
  );
}
